export default __webpack_public_path__ + "static/media/title.0cb22ca0.svg";